import axios from 'axios';
export const Instance = axios.create({
    baseURL: process.env.REACT_APP_.BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});